<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" @click="goMainPanel" />
    </div>

    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">?</div>
        <div class="greet">
          <h1>Ayuda</h1>
          <p class="sub">Reporta errores y revisa el seguimiento de solicitudes</p>
        </div>
      </div>
      <div class="header__right">
        <span class="hero-chip">Centro de soporte</span>
        <button class="btn btn--ghost" @click="goMainPanel">Regresar</button>
      </div>
    </header>

    <section class="menu-shell">
      <article
        v-if="canReportBug"
        class="menu-item menu-item--report"
        role="link"
        tabindex="0"
        @click="go('/ayuda/reportes')"
        @keyup.enter="go('/ayuda/reportes')"
      >
        <div class="menu-item__left">
          <span class="menu-icon">📝</span>
          <div class="menu-copy">
            <h2>Reportar</h2>
            <p>Crear reporte de error o solicitud y consultar "Mis reportes".</p>
          </div>
        </div>
        <router-link class="btn btn--primary" to="/ayuda/reportes">Entrar</router-link>
      </article>

      <article
        v-if="isBugReportAdmin"
        class="menu-item menu-item--admin"
        role="link"
        tabindex="0"
        @click="go('/ayuda/admin-reportes')"
        @keyup.enter="go('/ayuda/admin-reportes')"
      >
        <div class="menu-item__left">
          <span class="menu-icon">🛠️</span>
          <div class="menu-copy">
            <h2>Administrar reportes</h2>
            <p>Analizar reportes de usuarios y actualizar estatus/comentario.</p>
          </div>
        </div>
        <router-link class="btn btn--primary" to="/ayuda/admin-reportes">Entrar</router-link>
      </article>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'HelpModule',
  data() {
    return {
      permissions: [],
    }
  },
  computed: {
    canReportBug() {
      return this.hasPerm('maintenance.can_report_bug')
    },
    isBugReportAdmin() {
      return this.hasPerm('maintenance.is_bug_report_admin')
    },
  },
  created() {
    this.fetchCurrentUser()
  },
  methods: {
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.permissions = data.permissions || []
        if (!this.canReportBug && !this.isBugReportAdmin) {
          this.$router.push({ name: 'MainPanel' })
        }
      } catch (error) {
        this.$router.push({ name: 'MainPanel' })
      }
    },
    go(path) {
      this.$router.push(path)
    },
    goMainPanel() {
      this.$router.push({ name: 'MainPanel' })
    },
  },
}
</script>

<style scoped>
.main-panel {
  --radius-lg: 16px;
  --radius-md: 10px;
  --line: #e5e7eb;
  --shadow-soft: 0 10px 20px rgba(15, 23, 42, 0.08);
  min-height: 100vh;
  background: #f3f6fd;
  padding: 12vh 24px 48px;
}
.nav-bar-operations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  background-color: #ffc434;
  z-index: 1000;
  display: flex;
  align-items: center;
  padding-left: 16px;
}
.logo-button { height: 55%; object-fit: contain; cursor: pointer; }
.header {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: var(--radius-lg);
  padding: 14px 18px;
  backdrop-filter: blur(10px);
}
.header__left { display: flex; align-items: center; gap: 14px; }
.header__right { display: flex; align-items: center; gap: 8px; }
.avatar {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #ffc434, #ffe188);
  color: #3a2a00;
  font-weight: 800;
  box-shadow: 0 12px 24px rgba(77, 54, 0, 0.18);
}
.greet h1 { font-size: 1.2rem; color: #0f172a; margin: 0; }
.greet .sub { margin: 2px 0 0; color: #667085; font-size: .92rem; }
.hero-chip {
  border-radius: 999px;
  padding: 7px 12px;
  font-size: 0.78rem;
  font-weight: 700;
  border: 1px solid rgba(37, 99, 235, 0.35);
  background: rgba(37, 99, 235, 0.1);
  color: #1e40af;
}
.menu-shell {
  max-width: 860px;
  margin: 16px auto 0;
  display: grid;
  gap: 12px;
}
.menu-item {
  border-radius: var(--radius-lg);
  border: 1px solid var(--line);
  background: #fff;
  box-shadow: var(--shadow-soft);
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  transition: transform .16s ease, box-shadow .16s ease;
}
.menu-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 22px rgba(15, 23, 42, 0.12);
}
.menu-item__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.menu-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  font-size: 1.15rem;
  flex: 0 0 auto;
}
.menu-item--report .menu-icon { background: rgba(37, 99, 235, 0.14); }
.menu-item--admin .menu-icon { background: rgba(8, 145, 178, 0.16); }
.menu-copy h2 {
  margin: 0;
  color: #0f172a;
  font-size: 1rem;
}
.menu-copy p {
  margin: 3px 0 0;
  color: #475467;
  font-size: 0.9rem;
}
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  cursor: pointer;
  text-decoration: none;
  font-weight: 700;
  transition: all 0.16s ease;
}
.btn--primary {
  background: #2563eb;
  color: #fff;
}
.btn--ghost {
  background: #fff;
  border-color: #d0d7de;
  color: #0f172a;
}
.btn--primary:hover {
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.35);
}
.btn:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.2);
}
@media (prefers-reduced-motion: reduce) {
  .menu-item,
  .btn {
    transition: none;
  }
}
@media (max-width: 760px) {
  .menu-item {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
